import React from 'react';
import ContactForm from '../ContactForm';

const Contact = () => (
  <section id="contact" className="contact" aria-labelledby="contact-title">
    <div className="contact-info">
      <h2 id="contact-title">Tell us what you're trying to build.</h2>
      <p>In a 30-minute consult we'll map the risks, your architecture options and a rough delivery plan. You leave with:</p>
      <ul className="contact-benefits">
        <li>Architecture and security recommendations</li>
        <li>Options weighed on cost, return and timeline</li>
        <li>Clear next steps and a decision path</li>
      </ul>
      <address className="contact-details">
        <a href="mailto:business@omnistrix.com">business@omnistrix.com</a>
        <a href="tel:+60167103412">+60 16-710 3412</a>
        <span>MOX, Level 4, Sunway Putra Mall, 100, Jalan Putra, Chow Kit, 50350 Kuala Lumpur, Malaysia</span>
      </address>
    </div>
    <ContactForm />
  </section>
);

export default Contact;
